module.exports = __webpack_public_path__ + "img/img-3400-md@2x.d3ca3bab.jpg";